import ListVisits from "./listVisits";
const ListHomeVisits = () => <ListVisits type="home" />;
export default ListHomeVisits;